import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import "moment/locale/pt-br";
import styles from './styles.module.scss';
import { useGetUser } from '../../../hooks/useGetUser';
import { putFaq, postFaq, getFaqById, getSequenciaFaq } from '../../../services/api-auto';
import { useDispatch } from "react-redux";
import { 
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction
} from '../../../store/actions/snackbarActions.js';
import ModalLoading from '../../../components/ModalLoading';
import TextField from '@material-ui/core/TextField';
import { Select, MenuItem, InputLabel, FormControlLabel, Radio, RadioGroup, FormLabel, FormGroup } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import FormControl from '@material-ui/core/FormControl';
import MomentUtils from "@date-io/moment";
import ButtonsImagesCampain from '../../../components/ButtonsImagesCampain';
import { number } from '../../../services/mask';

const dataInit = {
    titulo: "",
    texto: "",
    periodoAtividade: 0,
    status: 1,
    dataInicio: null,
    dataFim: null,
    ativo: true,
    ordem: 1,
    logado: false
}


const FaqDetalhe = () => {
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const history = useHistory();
    const [data, setData] = useState(dataInit);
    const [indicarErros, setIndicarErros] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [faqId, setFaqId] = useState();

    const validarForm = () => {

        let valid = true;
        let msg = "";

        if(!data.titulo) {
            msg += `O campo Título é obrigatório. `; 
            valid = false; 
            showMsgW(msg)
        }
        if(data.periodoAtividade === 1 && (!data.dataInicio || !data.dataFim)) {
            msg += "As datas são obrigatórias quando o período de atividade for determinado. "; 
            valid = false; 
            showMsgW(msg)
        }
        if(!data.texto) {
            msg += "O campo Texto de destaque é obrigatório. "; 
            valid = false; 
            showMsgW(msg)
        }

        if(msg) 
            showMsgW(msg)

        setIndicarErros(!valid);
        return valid;
    }

    const getFaqIfEdit = async (id) => {

        if(id) {
            setModalLoading(true);
            try{
                const info = await getFaqById(id);
                info.data.status =  info.data.ativo ? 1 : 0;
                setData(info.data);

            } catch(e){
                showMsgW('Não foi possível carregar os dados');
            }
            setModalLoading(false);
        } else {
            var sequencia = await getSequenciaFaq();
            let dataModify = data;
            dataModify.ordem = sequencia.data;
            setData(dataModify);
        }
    }

    const enviar = async() => {
        setIndicarErros(false);
        if(validarForm()) {
            let formdata = data;

            formdata.dataInicio = formdata.periodoAtividade === 0 ? null : formdata.dataInicio;
            formdata.dataFim = formdata.periodoAtividade === 0 ? null : formdata.dataFim;
            formdata.ativo = formdata.status === 1;
            
            if( faqId !== null ) {
                setModalLoading(true);
                try{
                    let info = await putFaq(faqId, formdata);
                    showMsgS("Dados salvos com sucesso!")
                    setTimeout(()=>{
                        history.push('/faq')
                    }, 2000);
                } catch(e){
                    showMsgE("Ocorreu um erro ao salvar os dados")
                }
                setModalLoading(false);
            } else {
                setModalLoading(true);
                try{
                    let info = await postFaq(formdata);
                    showMsgS("Dados salvos com sucesso!")
                    setTimeout(()=>{
                        history.push('/faq');
                    }, 2000);
                } catch(e) {
                    showMsgE("Ocorreu um erro ao salvar os dados")
                }
                setModalLoading(false);
            }
        }
    }

    useEffect( () => {
        const id = new URLSearchParams(history.location.search).get("FaqId");
        setFaqId(id);
        getFaqIfEdit(id);
    },[])

    const user = useGetUser();
    
    return (
        <>
            {( user.perfilAcesso === 'Master' ) && (
                <>
                    <div className={styles.wrapper}>
                        <div className={styles.title}>
                            Pergunta e resposta
                            <button className={styles.backButton} onClick={() => {history.goBack()}}>
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                        </div>

                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card} style={{padding: '16px 16px 6px 16px'}}>
                                    <div className={styles.subtitle}>
                                        Configuração
                                    </div>
                                    <FormControl>
                                        <InputLabel id="select-status-label">
                                            Status
                                        </InputLabel>
                                        <Select
                                            labelId='select-status-label'
                                            label="Status"
                                            onChange={(e)=>{setData({...data, status: e.target.value})}}
                                            value={data.status}
                                            variant="filled"
                                            className="customFilledInput"
                                        >
                                            <MenuItem value={0}>Inativo</MenuItem>
                                            <MenuItem value={1}>Ativo</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl>
                                        <TextField  type="text"  size="small"
                                            onChange={(e) => {setData({ ...data, ordem:e.target.value})}}
                                            label="Ordem de exibição"
                                            value={number(data.ordem)}
                                            variant="filled"
                                            error={indicarErros && !data.ordem ? true : false}
                                            className="customFilledInput"
                                            disabled
                                        />
                                    </FormControl>

                                    <FormControl className={styles.halfRadio}>
                                        <div className={styles.subtitle2}>
                                            Período de atividade
                                        </div>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            defaultValue={0}
                                            value={data.periodoAtividade}
                                            style={{flexWrap: "nowrap"}}
                                            onChange={(e) => {setData({ ...data, periodoAtividade: parseInt(e.target.value) }) }}
                                        >
                                            <FormControlLabel value={0} control={<Radio style={{color: "#5CCBE1"}}/>} label="Indeterminado" />
                                            <FormControlLabel value={1} control={<Radio style={{color: "#5CCBE1"}}/>} label="Determinado" />
                                        </RadioGroup>
                                    </FormControl>
                                    
                                    <FormControl className={styles.data}>
                                        <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                label="De"
                                                format="DD/MM/yyyy"
                                                value={data.dataInicio}
                                                InputAdornmentProps={{ position: "start" }}
                                                onChange={novaData => { setData({ ...data, dataInicio: novaData}) }}
                                                className="customFilledInput"
                                                error={indicarErros && !data.dataInicio ? true : false}
                                                hidden={data.periodoAtividade === 0}
                                                invalidDateMessage="Data em formato inválido."
                                                maxDateMessage="Data não deve ser maior que a data máxima."
                                                minDateMessage="Data não deve ser menor que a data mínima."
                                            />
                                        </MuiPickersUtilsProvider>
                                    </FormControl>
                                    <FormControl className={styles.data}>
                                        <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                label="Até"
                                                format="DD/MM/yyyy"
                                                value={data.dataFim}
                                                InputAdornmentProps={{ position: "start" }}
                                                onChange={novaData => { setData({ ...data, dataFim: novaData}) }}
                                                className="customFilledInput"
                                                error={indicarErros && !data.dataFim ? true : false}
                                                hidden={data.periodoAtividade === 0}
                                                invalidDateMessage="Data em formato inválido."
                                                maxDateMessage="Data não deve ser maior que a data máxima."
                                                minDateMessage="Data não deve ser menor que a data mínima."
                                            />
                                        </MuiPickersUtilsProvider>
                                    </FormControl>
                                    <div className={styles.subtitle2}>
                                        Pergunta
                                    </div>
                                    <FormControl>
                                        <TextField  type="text"  size="small"
                                            onChange={(e) => {setData({ ...data, titulo:e.target.value})}}
                                            label="Pergunta"
                                            value={data.titulo}
                                            variant="filled"
                                            error={indicarErros && !data.titulo ? true : false}
                                            className="customFilledInput"
                                        />
                                    </FormControl>
                                    <div className={styles.subtitle2}>
                                        Resposta
                                    </div>                            
                                    <FormControl>
                                        <TextField  type="text"  size="small"
                                            onChange={(e) => {setData({ ...data, texto: e.target.value})}}
                                            label="Resposta"
                                            value={data.texto}
                                            variant="filled"
                                            error={indicarErros && !data.texto ? true : false}
                                            className="customFilledInput"
                                            multiline
                                            rows={10}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                        
                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>
                                    <div className={styles.subtitle}>
                                        Ações
                                    </div>
                                    <button className={styles.encerrar} onClick={() => {if(window.confirm("Deseja cancelar esta edição? Todos os dados não salvos serão perdidos.")) { history.push("/faq"); }}}>
                                        Cancelar
                                    </button>
                                    <button className={styles.salvar} onClick={enviar}>
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <ModalLoading
                        open={modalLoading} 
                        size="lg"
                    />
                </>
            )}
   
        </>
    );
}

export default FaqDetalhe;